export function domReady(listener) {
  if (document.readyState !== 'loading') {
    listener();
  } else {
    document.addEventListener('DOMContentLoaded', listener);
  }
}
//# sourceMappingURL=dom-ready.js.map